export default {"src":"/_next/static/image/public/images/ic_union_white.c8d7e147265e7e80c0455cde53001a1b.svg","height":16,"width":16};